module.exports = __webpack_public_path__ + "img/news_list_4.00375b16.jpg";